import React from 'react';
import { Check } from 'lucide-react';
import { processSteps, trustPoints } from '../../data/mock';

const ProcessSection = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-cyan-50 text-cyan-700 text-xs sm:text-sm font-medium mb-3 sm:mb-4 border border-cyan-200">
            Vertrauensaufbau
          </span>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-slate-800 mb-3 sm:mb-4">
            Unser Prozess in 3 Schritten
          </h2>
          <p className="text-sm sm:text-base text-slate-600 max-w-2xl mx-auto px-4">
            Transparent, strukturiert und zielgerichtet zum Erfolg.
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative mb-10 sm:mb-16">
          {/* Connection Line - Desktop only */}
          <div className="hidden lg:block absolute top-12 sm:top-16 left-[15%] right-[15%] h-px bg-slate-300" />
          
          <div className="grid sm:grid-cols-3 gap-4 sm:gap-8">
            {processSteps.map((process, index) => (
              <div key={index} className="relative">
                <div className="group p-5 sm:p-8 rounded-xl bg-white border border-slate-200 hover:border-cyan-300 hover:shadow-sm transition-all">
                  {/* Step Number */}
                  <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-cyan-700 flex items-center justify-center mb-4 sm:mb-6">
                    <span className="text-base sm:text-lg font-semibold text-white">{process.step}</span>
                  </div>
                  
                  <h3 className="text-base sm:text-lg font-semibold text-slate-800 mb-2 sm:mb-3">{process.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{process.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Trust Points */}
        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-2 sm:gap-4">
          {trustPoints.map((point, index) => (
            <div 
              key={index}
              className="flex items-center gap-2 sm:gap-3 px-4 sm:px-5 py-2.5 sm:py-3 rounded-lg bg-white border border-slate-200"
            >
              <div className="w-5 h-5 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                <Check className="w-3 h-3 text-emerald-600" />
              </div>
              <span className="text-slate-700 font-medium text-xs sm:text-sm">{point}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
